import { useTheme } from "@up/data";

import { BlockingErrorsMessage } from "../BlockingErrorsMessage";
import { useCart } from "../CartContext";
import { PaymentFree } from "../PaymentFree";
import { PaymentSection } from "../PaymentSection";
import { studentDataIsValid } from "../StudentSection";
import { PaymentTotals } from "./PaymentTotals";

type PaymentStepProps = {
  isFree: boolean;
  partnerSiteBaseURL: string;
  showDOB: boolean;
  stripePublicKey: string;
};

export function PaymentStep({
  isFree,
  partnerSiteBaseURL,
  showDOB,
  stripePublicKey,
}: PaymentStepProps) {
  const theme = useTheme();
  const cart = useCart();
  if (!cart.data) return null;

  return (
    <>
      <section
        data-testid="payment-section"
        id="payment-section"
        className="checkout-section"
      >
        <div className="flex items-center justify-between mb-3">
          <h2 className={`checkout-heading mb-2 ${theme.heading2Class}`}>
            Payment
          </h2>
          <PaymentTotals />
        </div>
        {isFree ? (
          <PaymentFree
            onSubmit={async () => {
              if (!studentDataIsValid(cart.data, showDOB)) {
                document
                  .getElementById("student-section")
                  ?.scrollIntoView({ behavior: "smooth" });
                return;
              }

              const { error } = await cart.finalValidate();
              if (error) {
                return;
              }

              cart.handleSubmitAsFree();
            }}
          />
        ) : (
          <div className="bg-gray-100 p-4 rounded">
            <PaymentSection
              setProcessing={(enable: boolean) => {
                cart[enable ? "submit" : "idle"]();
              }}
              stripePublicKey={stripePublicKey}
              successURL={`${partnerSiteBaseURL}/orders/${cart.data._id}?purchased=true`}
            />
          </div>
        )}
      </section>

      {cart.hasBlockingErrors ? (
        <BlockingErrorsMessage errors={cart.data?.errors} />
      ) : null}
      <br />
    </>
  );
}
